(function(){
  'use strict';
  function tuneLegacyChrome(root){
    if(!root||root.dataset.alpcChromeReady==='1')return;
    root.dataset.alpcChromeReady='1';

    var announcement=document.querySelector('.pk-clean-announcement__inner > span');
    if(announcement)announcement.textContent='30-day returns · Tracked shipping · Secure checkout';
    var announcementLink=document.querySelector('.pk-clean-announcement__inner > a');
    if(announcementLink)announcementLink.hidden=true;

    var headerCta=document.querySelector('.pk-clean-cta');
    if(headerCta){headerCta.textContent='Choose Your Setup';headerCta.setAttribute('href','#product-buy-box');}
    var finalCta=document.querySelector('.pq-final-cta__button');
    if(finalCta)finalCta.setAttribute('href','#product-buy-box');

    var footerCopy=document.querySelector('.pk-clean-footer__brand p');
    if(footerCopy)footerCopy.textContent='Everyday ergonomic comfort for work, travel and home—designed to make the seats you already use feel better.';

    var offerTitle=document.querySelector('[data-pkmc-offer-title]');
    var offerText=document.querySelector('[data-pkmc-offer-text]');
    if(offerTitle)offerTitle.textContent='Your selected comfort setup';
    if(offerText)offerText.textContent='Review your colors and items before secure checkout.';
    var trust=document.querySelectorAll('.pkmc__trust span');
    if(trust[0])trust[0].lastChild.textContent=' Tracked shipping';
    if(trust[1])trust[1].lastChild.textContent=' 30-day returns';
    if(trust[2])trust[2].lastChild.textContent=' Secure checkout';
    var emptyTitle=document.querySelector('.pkmc__empty h3');
    var emptyText=document.querySelector('.pkmc__empty p');
    if(emptyTitle)emptyTitle.textContent='Your cart is ready when you are';
    if(emptyText)emptyText.textContent='Add an Aarna comfort essential and it will appear here.';
  }
  function init(root){
    if(!root||root.dataset.alpcReady==='1')return;
    root.dataset.alpcReady='1';
    tuneLegacyChrome(root);
    var sticky=root.querySelector('[data-alpc-sticky]');
    var button=root.querySelector('[data-alpc-sticky-buy]');
    if(!sticky||!button)return;

    function purchaseTarget(){
      return root.querySelector('[data-pkbb-root]')||root.querySelector('.pkgp__form');
    }
    function update(){
      if(window.innerWidth>749){sticky.classList.remove('is-visible');sticky.setAttribute('aria-hidden','true');return;}
      var info=root.querySelector('.pkgp__info');
      var target=purchaseTarget();
      if(!info||!target)return;
      var infoRect=info.getBoundingClientRect();
      var targetRect=target.getBoundingClientRect();
      var targetVisible=targetRect.top<window.innerHeight-72&&targetRect.bottom>76;
      var show=infoRect.top<-170&&!targetVisible;
      sticky.classList.toggle('is-visible',show);
      sticky.setAttribute('aria-hidden',show?'false':'true');
    }
    button.addEventListener('click',function(){
      var target=purchaseTarget();
      if(!target)return;
      target.scrollIntoView({behavior:'smooth',block:'center'});
      var focusable=target.querySelector('[data-pkbb-tier-select],button,select');
      if(focusable)setTimeout(function(){focusable.focus({preventScroll:true});},450);
    });
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    setTimeout(update,120);
  }
  function scan(){document.querySelectorAll('[data-alpc-root]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();
